import React from 'react';

// tslint:disable max-line-length
const CChoosePart1Demo: React.FC = () => (
  <>
    <h5>Choosing part 1</h5>
    <p>Right. It’s time to get out there. Let that person be your filter as you walk – ignore the things you know they’re not going to care about, go and learn more about the objects you know nothing about. Let them know the effort you’ve gone to, to choose the right things. Keep walking as you start to browse slowly. The first thing you choose – why is it right for this person? Is it going to trigger a memory of time you spent together?  Does it shine out in their favourite colour? Or you are you choosing this object for the story it comes with already? The powerful history this thing carries with it – maybe that’s something you want to give?  It’s this person, these objects, and you.  Bring them together..</p>
  </>
);

export {
  CChoosePart1Demo,
};
